//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

export const createSenteceStarter = (returnedPayload) => ({
  type: ActionTypes.sentenceStarter.createSenteceStarter,
  payload: returnedPayload,
});
export const updateSenteceStarter = (returnedPayload) => ({
  type: ActionTypes.sentenceStarter.updateSenteceStarter,
  payload: returnedPayload,
});

export const listSenteceStarter = (returnedPayload) => ({
  type: ActionTypes.sentenceStarter.listSenteceStarter,
  payload: returnedPayload,
});

export const deleteSenteceStarter = (returnedPayload) => ({
  type: ActionTypes.sentenceStarter.deleteSenteceStarter,
  payload: returnedPayload,
});


// pop up
export const updatePopUpHandler = (returnedPayload) => ({
  type: ActionTypes.sentenceStarterPopup.updateOpenPopup,
  payload: returnedPayload,
});

export const setPopUpHandler = (returnedPayload) => ({
    type: ActionTypes.sentenceStarterPopup.setOpenPopup,
    payload: returnedPayload,
  });